// account-cabinet-self-progress-tabs.simple.js
import axios from 'axios';
import {
    initPersonalAccountTabProgressHistory
} from "./account-cabinet-self-progress-history/account-cabinet-self-progress-history";
import {
    initPersonalAccountTabProgressProfile
} from "./account-cabinet-self-progress-profile/account-cabinet-self-progress-profile";
import {initPersonalAccountTabProgressMy} from "./account-cabinet-self-progress-my/account-cabinet-self-progress-my";

const DATA_ATTR = 'data-account-cabinet-self-progress';
const CLASS_PREFIX = 'account-cabinet-self-progress';
const TAB_ATTR = `${DATA_ATTR}-nav`;
const PANEL_ATTR = `${DATA_ATTR}-panel`;

export function initPersonalAccountTabProgress($container, _userData) {
    const $templateMain = document.querySelector(`[${DATA_ATTR}-template-main]`);

    let $mainFragment = null
    let $tabs = null
    let $logout = null
    let $contentContainer = null

    let userData = {}

    init();

    async function init() {
        if (!$templateMain) return;
        userData = _userData;
        renderMain();
        //await fetchUserData();
    }

    function fetchUserData() {
        axios.get('/api/user')
            .then((response) => {

            })
            .catch((error) => {
                console.error('Error fetching user data:', error);
            });
    }

    function renderMain() {
        $mainFragment = $templateMain.content.cloneNode(true);
        $tabs = Array.from($mainFragment.querySelectorAll(`[${TAB_ATTR}]`));
        $logout = $mainFragment.querySelector(`[${DATA_ATTR}-logout]`);
        $contentContainer = $mainFragment.querySelector(`[${DATA_ATTR}-content]`);
        initProfileCard()
        $container.appendChild($mainFragment);


        const start = $tabs.find(t => t.getAttribute('aria-selected') === 'true') || $tabs[0];
        if (start) {
            initTabs();
            setActive(start.getAttribute(TAB_ATTR));
        }
        $logout.addEventListener('click', (e) => {
            e.preventDefault();
            submitLogout();
        });

        document.dispatchEvent(new CustomEvent('account-cabinet:render-complete', {bubbles: true}));
    }

    function initProfileCard() {
        const $profileCard = $mainFragment.querySelector(`[${DATA_ATTR}-profile]`);
        if ($profileCard) {
            console.log('userData.avatar',userData.avatar);
            if (userData.avatar) {
                $profileCard.querySelector(`[${DATA_ATTR}-profile-img]`).src = 'storage/' + userData.avatar;
            }
            else {
                $profileCard.querySelector(`[${DATA_ATTR}-profile-img]`).style.display = 'none';
            }

            $profileCard.querySelector(`[${DATA_ATTR}-profile-name]`).textContent = userData.name;
            $profileCard.querySelector(`[${DATA_ATTR}-profile-role]`).textContent = userData.role?.name || '';
            $profileCard.querySelector(`[${DATA_ATTR}-profile-university]`).textContent = userData.university?.name || '';
        }
    }

    function setActive(name) {
        if (!name) return;
        $contentContainer.innerHTML = '';

        $tabs.forEach(tab => {
            const tabName = tab.getAttribute(TAB_ATTR);
            const active = tabName === name;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.classList.toggle(`${CLASS_PREFIX}__nav-item--active`, active);
        });

        switch (name) {
            case 'self-progress':
                initPersonalAccountTabProgressMy($contentContainer);
                break;
            case 'profile-settings':
                initPersonalAccountTabProgressProfile($contentContainer, userData);
                break;
            case 'view-history':
                initPersonalAccountTabProgressHistory($contentContainer);
                break;
            default:
                break;
        }

    }

    function initTabs() {
        $tabs.forEach(tab => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                setActive(tab.getAttribute(TAB_ATTR));
            });
        });
    }

    async function submitLogout() {
        try {
            await axios.post('/logout');
            window.location.href = '/';
        } catch (error) {
            console.error('Ошибка при логауте:', error);
        }
    }

    return {setActive};
}
